/* tslint:disable */
/* eslint-disable */
/**
 * compass-pro
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { UserHistoryObservedEmergencyModel } from './UserHistoryObservedEmergencyModel';
import {
    UserHistoryObservedEmergencyModelFromJSON,
    UserHistoryObservedEmergencyModelFromJSONTyped,
    UserHistoryObservedEmergencyModelToJSON,
    UserHistoryObservedEmergencyModelToJSONTyped,
} from './UserHistoryObservedEmergencyModel';
import type { ContactWithoutAccountModel } from './ContactWithoutAccountModel';
import {
    ContactWithoutAccountModelFromJSON,
    ContactWithoutAccountModelFromJSONTyped,
    ContactWithoutAccountModelToJSON,
    ContactWithoutAccountModelToJSONTyped,
} from './ContactWithoutAccountModel';

/**
 * 
 * @export
 * @interface AllMergedUsersModel
 */
export interface AllMergedUsersModel {
    /**
     * 
     * @type {string}
     * @memberof AllMergedUsersModel
     */
    org_code: string;
    /**
     * 
     * @type {string}
     * @memberof AllMergedUsersModel
     */
    auth_id: string;
    /**
     * 
     * @type {string}
     * @memberof AllMergedUsersModel
     */
    first_name: string;
    /**
     * 
     * @type {string}
     * @memberof AllMergedUsersModel
     */
    last_name: string;
    /**
     * 
     * @type {string}
     * @memberof AllMergedUsersModel
     */
    phone_number: string;
    /**
     * 
     * @type {string}
     * @memberof AllMergedUsersModel
     */
    role: string;
    /**
     * 
     * @type {string}
     * @memberof AllMergedUsersModel
     */
    org_spec_azure_id: string;
    /**
     * 
     * @type {string}
     * @memberof AllMergedUsersModel
     */
    org_user_azure_id: string;
    /**
     * 
     * @type {string}
     * @memberof AllMergedUsersModel
     */
    org_user_etag: string;
    /**
     * 
     * @type {number}
     * @memberof AllMergedUsersModel
     */
    org_user_ts: number;
    /**
     * 
     * @type {{ [key: string]: UserHistoryObservedEmergencyModel; }}
     * @memberof AllMergedUsersModel
     */
    observed_emergencies?: { [key: string]: UserHistoryObservedEmergencyModel; } | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof AllMergedUsersModel
     */
    read_inbox_message_names?: Array<string> | null;
    /**
     * 
     * @type {string}
     * @memberof AllMergedUsersModel
     */
    user_history_azure_id: string;
    /**
     * 
     * @type {string}
     * @memberof AllMergedUsersModel
     */
    user_history_etag: string;
    /**
     * 
     * @type {number}
     * @memberof AllMergedUsersModel
     */
    user_history_ts: number;
    /**
     * 
     * @type {boolean}
     * @memberof AllMergedUsersModel
     */
    arc_flash_detection_on: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AllMergedUsersModel
     */
    fall_detection_on: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AllMergedUsersModel
     */
    head_impact_detection_on: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AllMergedUsersModel
     */
    mute_sos_button: boolean;
    /**
     * 
     * @type {{ [key: string]: ContactWithoutAccountModel; }}
     * @memberof AllMergedUsersModel
     * @deprecated
     */
    contacts_without_accounts?: { [key: string]: ContactWithoutAccountModel; } | null;
    /**
     * 
     * @type {string}
     * @memberof AllMergedUsersModel
     */
    user_private_settings_azure_id: string;
    /**
     * 
     * @type {string}
     * @memberof AllMergedUsersModel
     */
    user_private_settings_etag: string;
    /**
     * 
     * @type {number}
     * @memberof AllMergedUsersModel
     */
    user_private_settings_ts: number;
}

/**
 * Check if a given object implements the AllMergedUsersModel interface.
 */
export function instanceOfAllMergedUsersModel(value: object): value is AllMergedUsersModel {
    if (!('org_code' in value) || value['org_code'] === undefined) return false;
    if (!('auth_id' in value) || value['auth_id'] === undefined) return false;
    if (!('first_name' in value) || value['first_name'] === undefined) return false;
    if (!('last_name' in value) || value['last_name'] === undefined) return false;
    if (!('phone_number' in value) || value['phone_number'] === undefined) return false;
    if (!('role' in value) || value['role'] === undefined) return false;
    if (!('org_spec_azure_id' in value) || value['org_spec_azure_id'] === undefined) return false;
    if (!('org_user_azure_id' in value) || value['org_user_azure_id'] === undefined) return false;
    if (!('org_user_etag' in value) || value['org_user_etag'] === undefined) return false;
    if (!('org_user_ts' in value) || value['org_user_ts'] === undefined) return false;
    if (!('user_history_azure_id' in value) || value['user_history_azure_id'] === undefined) return false;
    if (!('user_history_etag' in value) || value['user_history_etag'] === undefined) return false;
    if (!('user_history_ts' in value) || value['user_history_ts'] === undefined) return false;
    if (!('arc_flash_detection_on' in value) || value['arc_flash_detection_on'] === undefined) return false;
    if (!('fall_detection_on' in value) || value['fall_detection_on'] === undefined) return false;
    if (!('head_impact_detection_on' in value) || value['head_impact_detection_on'] === undefined) return false;
    if (!('mute_sos_button' in value) || value['mute_sos_button'] === undefined) return false;
    if (!('user_private_settings_azure_id' in value) || value['user_private_settings_azure_id'] === undefined) return false;
    if (!('user_private_settings_etag' in value) || value['user_private_settings_etag'] === undefined) return false;
    if (!('user_private_settings_ts' in value) || value['user_private_settings_ts'] === undefined) return false;
    return true;
}

export function AllMergedUsersModelFromJSON(json: any): AllMergedUsersModel {
    return AllMergedUsersModelFromJSONTyped(json, false);
}

export function AllMergedUsersModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): AllMergedUsersModel {
    if (json == null) {
        return json;
    }
    return {
        
        'org_code': json['org_code'],
        'auth_id': json['auth_id'],
        'first_name': json['first_name'],
        'last_name': json['last_name'],
        'phone_number': json['phone_number'],
        'role': json['role'],
        'org_spec_azure_id': json['org_spec_azure_id'],
        'org_user_azure_id': json['org_user_azure_id'],
        'org_user_etag': json['org_user_etag'],
        'org_user_ts': json['org_user_ts'],
        'observed_emergencies': json['observed_emergencies'] == null ? undefined : (mapValues(json['observed_emergencies'], UserHistoryObservedEmergencyModelFromJSON)),
        'read_inbox_message_names': json['read_inbox_message_names'] == null ? undefined : json['read_inbox_message_names'],
        'user_history_azure_id': json['user_history_azure_id'],
        'user_history_etag': json['user_history_etag'],
        'user_history_ts': json['user_history_ts'],
        'arc_flash_detection_on': json['arc_flash_detection_on'],
        'fall_detection_on': json['fall_detection_on'],
        'head_impact_detection_on': json['head_impact_detection_on'],
        'mute_sos_button': json['mute_sos_button'],
        'contacts_without_accounts': json['contacts_without_accounts'] == null ? undefined : (mapValues(json['contacts_without_accounts'], ContactWithoutAccountModelFromJSON)),
        'user_private_settings_azure_id': json['user_private_settings_azure_id'],
        'user_private_settings_etag': json['user_private_settings_etag'],
        'user_private_settings_ts': json['user_private_settings_ts'],
    };
}

export function AllMergedUsersModelToJSON(json: any): AllMergedUsersModel {
    return AllMergedUsersModelToJSONTyped(json, false);
}

export function AllMergedUsersModelToJSONTyped(value?: AllMergedUsersModel | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'org_code': value['org_code'],
        'auth_id': value['auth_id'],
        'first_name': value['first_name'],
        'last_name': value['last_name'],
        'phone_number': value['phone_number'],
        'role': value['role'],
        'org_spec_azure_id': value['org_spec_azure_id'],
        'org_user_azure_id': value['org_user_azure_id'],
        'org_user_etag': value['org_user_etag'],
        'org_user_ts': value['org_user_ts'],
        'observed_emergencies': value['observed_emergencies'] == null ? undefined : (mapValues(value['observed_emergencies'], UserHistoryObservedEmergencyModelToJSON)),
        'read_inbox_message_names': value['read_inbox_message_names'],
        'user_history_azure_id': value['user_history_azure_id'],
        'user_history_etag': value['user_history_etag'],
        'user_history_ts': value['user_history_ts'],
        'arc_flash_detection_on': value['arc_flash_detection_on'],
        'fall_detection_on': value['fall_detection_on'],
        'head_impact_detection_on': value['head_impact_detection_on'],
        'mute_sos_button': value['mute_sos_button'],
        'contacts_without_accounts': value['contacts_without_accounts'] == null ? undefined : (mapValues(value['contacts_without_accounts'], ContactWithoutAccountModelToJSON)),
        'user_private_settings_azure_id': value['user_private_settings_azure_id'],
        'user_private_settings_etag': value['user_private_settings_etag'],
        'user_private_settings_ts': value['user_private_settings_ts'],
    };
}

